// extracted by mini-css-extract-plugin
module.exports = {"paginatedList":"PaginatedList_paginatedList__HoR4P","navControls":"PaginatedList_navControls__2Cndp","navButton":"PaginatedList_navButton__3cvQB"};